<template>
  <div>
    <template v-if="type === 'award'">
      <div class="timeline-pointer award-pointer flex-center">
        <i class="award-icon"></i>
      </div>
    </template>
    <span :class="'timeline-pointer ' + type" v-else></span>
  </div>
</template>

<script>
export default {
  name: 'EventTimelinePointer',
  props: ['type']
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';
.timeline-pointer {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  position: absolute;
  left: -25px;
  top: 14px;
  transform: translateX(-0.5px);

  &.on-track,
  &.behind,
  &.at-risk {
    border: 2px solid $documentColor;
    transform: translateX(-2.5px);
    box-sizing: content-box;
  }

  &.on-track {
    box-shadow: 0 0 0 1px $active;
    background-color: $active;
  }

  &.behind {
    box-shadow: 0 0 0 1px $warning;
    background-color: $warning;
  }

  &.at-risk {
    box-shadow: 0 0 0 1px $error;
    background-color: $error;
  }
}
.award-pointer {
  @include dimension(21px, 21px);

  background-color: $quinary;
  border-radius: 50%;
  left: -30px;
  top: 11px;

  .award-icon {
    margin-top: 1px;
  }
}
</style>
